import React, { useEffect, useState } from "react";
export default function ToggleButton({
  defaultValue,
  dispatchItemToredux,
  //dispatchItemToredux
  setToggleValue,
  reduxKey,
}) {
  const [isToggled, setIsToggled] = useState(defaultValue);
  // console.log(defaultValue);
  // console.log(isToggled);
  const handleToggle = () => {
    const newToggleState = !isToggled;
    // console.log(newToggleState);
    setIsToggled(newToggleState);
    if (setToggleValue) {
      setToggleValue(newToggleState);
    }
    if (dispatchItemToredux) {
      dispatchItemToredux(newToggleState, reduxKey);
    }
  };
  useEffect(() => {
    setIsToggled(defaultValue);
  }, [defaultValue]);

  return (
    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        id={reduxKey}
        className="sr-only"
        checked={isToggled}
        onChange={handleToggle}
      />
      <label
        htmlFor={reduxKey}
        className={`mb-[3px] relative w-[36px] h-[18px] flex items-center cursor-pointer border-[0px] border-gray-100 rounded-full ${
          isToggled ? "bg-[#5AC189]" : "bg-[#f85353]"
        }`}
      >
        <div className="rounded-full shadow-inner flex items-center text-white font-bold text-[8px] pl-[3px]">
          ON
        </div>
        <div
          className={`z-5 rounded-full absolute w-[16px] h-[16px] transition-transform duration-300 ${
            isToggled
              ? "bg-white transform translate-x-[120%]"
              : "bg-white transform translate-x-[6%]"
          }`}
        ></div>
        <div className="rounded-full shadow-inner text-[8px] flex items-center text-white font-bold relative left-[3px]">
          OFF
        </div>
      </label>
    </div>
  );
}
